import { createContext, useContext } from "react";
import { ToastContainer } from "react-toastify"
import 'react-toastify/dist/ReactToastify.css';
import { message } from "../utils/message";

const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
    const notify = (response) => {
        message(response);
    }

    return <ToastContext.Provider value={{ notify }}>
        <ToastContainer />
        {children}
    </ToastContext.Provider >
}

export const useToast = () => {
    return useContext(ToastContext);
}